import type { AssociationIds } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type PushedToBimtrackEvent = AvvirEvent<typeof PUSHED_TO_BIMTRACK, { scanDatasetId: string, floorId: string, globalId: string }>

const pushedToBimtrack = ({ floorId, scanDatasetId, globalId }: AssociationIds): PushedToBimtrackEvent => ({
  type: PUSHED_TO_BIMTRACK,
  payload: {
    scanDatasetId,
    floorId,
    globalId
  }
});

export const PUSHED_TO_BIMTRACK = "pushed_to_bimtrack";

export default pushedToBimtrack;
